import moment from "moment";

export function dateOnly(date?: string | Date) {
  if (!date) return "";
  return moment(date).format("L");
}
export function dateTime(date?: string | Date) {
  if (!date) return "";
  return moment(date).format("L hh.mmA");
}
